import { v4 as uuidv4 } from "uuid";

export const getDeviceId = (): string => {
  const storedId: string | null = localStorage.getItem("deviceId");

  if (storedId) {
    return storedId;
  }

  const newId: string = uuidv4(); // explicitly typed
  localStorage.setItem("deviceId", newId);
  return newId;
};
